export default __webpack_public_path__ + "0f4b40062449e0df225f323fd6af5356.png";